import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

@Injectable()
export class CalibrationScheduleService extends ApiService {
    protected baseUrl = '';

    public validateUrl = 'card/validate-calibration-schedule-document';
    public generateUrl = 'card/generate-calibration-schedule-document';
}
